import React from 'react';
import AppShell from '../../components/layout/AppShell';
import '../auth.css';
import './invite.css';

export default function InviteExpiredPage(): React.JSX.Element {
  return (
    <AppShell showNav={false} showFooter={false}>
      <div className="invite-page">
        <section className="invite-card">
          <h1 className="invite-title">This invitation is no longer valid.</h1>
          <p className="invite-body">
            The link may have expired or already been used. Contact your administrator for a new
            invitation.
          </p>
        </section>
      </div>
    </AppShell>
  );
}
